import React from "react";
import styled from "styled-components/native";
import { VDBText } from "..";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTranslation } from "react-i18next";
import { SpaceType } from "../Spacer/types";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { DefaultTheme } from "styled-components/native";

const VDBFooter = () => {
  const isCustomApp = useSelector((state: any) => state.appState?.isCustomApp);
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const { showPoweredByVDB } = useOrgSettingsSlice();
  return (
    <Overlay>
      {(!isCustomApp || (isCustomApp && showPoweredByVDB)) && (
        <VDBText color={theme["core-06"]} style={typography["Minor-R"]}>
          {t("global.text.powerdBy")}
        </VDBText>
      )}
    </Overlay>
  );
};

const Overlay = styled.View`
  padding: ${({ theme }: { theme: DefaultTheme }) =>
    !theme.isLargeScreen ? `${SpaceType.Big}px ${SpaceType.Basic}px` : "0"};
  align-items: center;
`;

export default VDBFooter;
